import { render, staticRenderFns } from "./TotalRuleConfig.vue?vue&type=template&id=3849ffc6&scoped=true"
import script from "./TotalRuleConfig.vue?vue&type=script&lang=js"
export * from "./TotalRuleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849ffc6",
  null
  
)

export default component.exports